import { takeLatest, call, select, take } from 'redux-saga/effects';

import {
  getSupportedEventTypesIfNeeded,
  getEventMetaDataIfNeeded
} from './sagas';

import { GET_SUPPORTED_EVENT_TYPES, GET_EVENT_META_DATA } from './actions';
import { actions as UserActions } from 'store/user';

/* Helper Sagas */

function* waitForUserReady() {
  const userReady = yield select(store => store.user.ready);
  if (!userReady) {
    yield take(UserActions.LOGIN_READY);
  }
}

/* APP FLOW - Campaigns */
function* AllSupportedEventTypesGetSaga() {
  yield takeLatest(GET_SUPPORTED_EVENT_TYPES, function*(action) {
    yield call(waitForUserReady);
    yield call(getSupportedEventTypesIfNeeded, action);
  });
}

function* GetEventMetaDataSaga() {
  yield takeLatest(GET_EVENT_META_DATA, function*(action) {
    yield call(waitForUserReady);
    yield call(getEventMetaDataIfNeeded, action);
  });
}

export default [AllSupportedEventTypesGetSaga, GetEventMetaDataSaga];
